<template>
  <div class="form_root">
    <div class="text-left">
      <h3>
        <router-link to="/emails">Email</router-link> » {{crud_action}}
        <button v-if="!loading" @click.prevent="save()" class="btn btn-success pull-right">Salvar</button>
        <button v-else class="btn btn-muted pull-right">Aguarde...</button>
      </h3>
      <hr>
    </div>
    <!-- EMAIL -->
    <div class="form-group col-sm-8">
        <label class="control-label">Assunto</label>
        <input type="text" v-model="form.assunto" placeholder="Assunto do Email" class="form-control"/>
    </div>
    <div class="form-group col-sm-4">
        <label class="control-label">Destinatários</label>
        <select v-model="tpMailList" id="" class="form-control">
            <option value="0">Escolher depois</option>
            <option value="1">Pagadores ( Manda 1 email para cada cliente com R$ > 0 )</option>
            <option value="2">Todos ( Manda email para todos os emails cadastrados )</option>
        </select>
    </div>
    <div class="col-sm-12">
      <label class="control-label">Corpo do Email</label>
      <wysiwyg ref="conteudo"></wysiwyg>
    </div>
    <br><br><br>
  </div>
</template>

<script>
import wysiwyg from './Wysiwyg'
import swal from 'sweetalert'
export default {
  name: '',
  components: {
    wysiwyg
  },
  data () {
    return {
      loading: false,
      crud_action: '',
      tpMailList: '0',
      form: {
        cod: 0,
        assunto: '',
        conteudo: ''
      },
      maillist: {
        clientes: [],
        current: 0,
        nrows: 0
      }
    }
  },
  methods: {
    load (params = '') {
      const url = './api/php/getemail.php'
      this.$http.post(url, JSON.stringify(params)).then(
        function (response) {
          console.log(response.body)
          this.fetchData(response.body)
        },
        function (error) {
          console.log(error)
        }
      )
    },
    fetchData (o) {
      this.form = o
      this.$refs.conteudo.setContent(o.conteudo)
    },
    loadClientes (params = '') {
      const url = './api/php/getcliente.php'
      this.$http.post(url, JSON.stringify(params)).then(
        function (response) {
          console.log(response.body)
          if (response.body.length) {
            this.maillist.clientes = response.body
            this.maillist.nrows = response.body.length
            this.addMailList()
          } else {
            swal('Ops!', 'Ocorreu um erro ao adicionar automaticamente os emails. Você pode adicioná-los manualmente depois.', 'error')
          }
        },
        function (error) {
          console.log(error)
        }
      )
    },
    save () {
      this.form.conteudo = this.$refs.conteudo.getContent()
      const url = './api/php/addemail.php'
      this.$http.post(url, JSON.stringify(this.form)).then(
        function (response) {
          console.log(response.body)
          if (response.body.status) {
            this.form = response.body.form
            if (response.body.action === 'add') {
              swal('Email salvo.', '', 'success')
              if (this.tpMailList === '1') {
                this.loadClientes({'cob': true})
              } else if (this.tpMailList === '2') {
                this.loadClientes()
              }
            } else {
              swal('Email alterado', '', 'success')
            }
          } else {
            swal('Ocorreu um erro inesperado', response.body.text, 'error')
          }
          this.closeForm()
        },
        function (error) {
          console.log(error)
        }
      )
    },
    saveMailList (form) {
      const url = './api/php/addemaillist.php'
      this.$http.post(url, JSON.stringify(form)).then(
        function (response) {
          if (response.body.status) {
            if (this.maillist.current < this.maillist.nrows) {
              this.addMailList()
            }
          } else {
            console.log(response.body)
          }
        },
        function (error) {
          console.log(error)
        }
      )
    },
    addMailList () {
      const raw = this.maillist.clientes[this.maillist.current++]
      let form = {}
      form.email = this.filterMails(raw.email)
      if (form.email) {
        form.codemail = this.form.cod
        form.codcli = raw.cod
        this.saveMailList(form)
      } else {
        if (this.maillist.current < this.maillist.nrows) {
          this.addMailList()
        }
      }
    },
    filterMails (emails) {
      if (emails[0] !== undefined && emails[0].endereco.indexOf('@') >= 1) {
        return emails[0].endereco
      } else {
        return false
      }
    },
    closeForm () {
      if (this.tpMailList === '1') {
        swal('Sucesso', 'Lista configurada com os emails dos PAGADORES', 'success')
      } else if (this.tpMailList === '2') {
        swal('Sucesso', 'Lista configurada com os emails de TODOS OS CLIENTES', 'success')
      }
      this.$router.push({path: '/emails'})
    }
  },
  created: function () {
    const crud = this.$route.params.crud
    const cod = this.$route.params.id
    if (crud === 'c') {
      // Criar novo email
      console.log('Criando novo email')
      this.crud_action = 'Novo'
      // this.form.codautor = this.$root.cod
      this.loadCliente(cod)
    } else if (crud === 'u') {
      // Altera um email
      console.log('Alterando um email')
      this.crud_action = 'Alterando (#' + cod + ')'
      this.load({'cod': cod})
    } else {
      console.log('CRUD INVÁLIDO EM FORM EMAIL')
    }
  }
}
</script>

<style scoped>
  .loading {
    background: url("../assets/loading.gif") center no-repeat;
    background-size: cover;
    display: block;
    width: 30vw;
    height: 30vh;
    margin: 25vh 35vw;
  }
  .form_root {
      text-align: left;
      margin: auto;
      width: 80vw;
    }
    .form_root label {
      color: #444;
    }
    .form_root >>> .form-control {
      padding: 5px;
    }
    .form_root >>> .glyphicon-remove {
      color: #c00;
    }
    .form_root >>> .root ul li {
        background: #e1e1e1;
        margin: 10px;
        padding: 10px;
    }
    .form_root >>> .form {
        background: #ccc;
        padding: 15px 0 15px 0;
    }
    input[type="checkbox"] {
      margin-right: 10px;
    }
    .up {
      text-transform: uppercase;
    }
    .btn-danger {
      margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/EmailForm.vue